import React from "react";
import "containers/Projects/ActiveProject/Step_3/LearnNewSkill/LearnNewSkill.css";
import Video from "components/General/Video/Video.js";
import ProgressStepper from "components/Project/ProgressStepper";
import ProjectBanner from "components/Project/ProjectBanner";
import TwoButtonLayout from "components/General/Form/CustomButton/TwoButtonLayout";
import ProjectOldInfo from "components/Project/Details/ProjectOldInfo";
import TextTheme from "components/General/Text/TextTheme";
import TextArea from "components/General/Form/TextArea";
import Input from "components/General/Form/Input";

/**
 * @description Creates a form displaying all the information of the Challenge 3 Develop new habit
 * @class DevelopNewHabitComponent
 * @implements ProgressStepper, ProjectBanner, ProjectInfo, Video
 * @extends React.Component
 * @type {DevelopNewHabitComponent}
 * @example <DevelopNewHabitComponent />
 * pre-condition: all the imports
 * post-condition: returns a form with all the information about develop new habit
 * @param project_banner, project_name, project_badge, project_join_date, challenge_status, new_habit, description,
 * changeHandler, videoHandler, saveHandler
 * @returns {DevelopNewHabitComponent}
 */

class DevelopNewHabitComponent extends React.Component {

  render() {
    return (
      <div className="header_main">
        <div className="page_main">
          <div className="page_info_vr_content_main">
            <ProjectOldInfo vertical={true} project={this.props.projectSlug} />
          </div>
          <div className="page_details_main">
            <div className="project-banner">
              <ProjectBanner image={this.props.projectBanner} />
            </div>
            <div className="page_info_hr_content_main">
              <ProjectOldInfo
                project={this.props.projectSlug}
                showChallengeDetails={true}
              />
            </div>
            <div className="page_details_content_main border-0">
              <div className="stepper_main_content">
                <ProgressStepper
                  currentStep="4"
                  challengeSlug={this.props.challengeSlug}
                  goalDate={this.props.goalDate}
                  adventureId={this.props.adventureId}
                  projectSlug={this.props.projectSlug}
                  adventureSlug={this.props.adventureSlug}
                  isInvite={this.props.isInvite}
                  email={this.props.email}
                  invitationId={this.props.invitationId}
                  projectUserId={this.props.projectUserId}
                  showStepper={this.props.showStepper}
                />
              </div>
            </div>
            <div className="page_details_content_main">
              <div className="project-details">
                <div className="insideContent">
                  {this.props.isInvite ? (
                    <h3 className="textHeader">STEP 2 : MAKE AN IMPACT</h3>
                  ) : (
                    <h3 className="textHeader">STEP 5 : MAKE AN IMPACT</h3>
                  )}
                </div>
              </div>
              <TextTheme
                message="DEVELOP A NEW HABIT"
                className="mt-15 text_medium aboutMeTitle text_semi_bold d-inline-block mb-15"
              />
              <TextTheme
                message="Develop a new habit that will support the mission of the
                  project."
                className="text_medium text_black"
              />
              <div className="project-form-inner">
                <TextTheme
                  message="1. What new habit did you develop?"
                  className="mt-30 text_small text_black"
                />
                <Input
                  type="text"
                  name="newHabit"
                  value={this.props.defaultIfEmpty(this.props.newHabit)}
                  handleChange={this.props.changeHandler}
                />
                {!this.props.hasHabit ? (
                  <TextTheme
                    message="Please share the new habit you developed"
                    className="mt-1 text_small text_red"
                  />
                ) : null}
                <TextTheme
                  message="2. Describe how you learned your new habit."
                  className="mt-30 text_small text_black"
                />
                <TextArea
                  name="description"
                  rows={3}
                  cols={80}
                  value={this.props.defaultIfEmpty(this.props.description)}
                  handleChange={this.props.changeHandler}
                />
                {!this.props.hasDescription ? (
                  <TextTheme
                    message="Please share the description of your activity"
                    className="mt-1 text_small text_red"
                  />
                ) : null}
                <TextTheme
                  message="3. Share a video or photo that celebrates your new habit."
                  className="mt-30 text_small text_black"
                />
              </div>
              <div className="d-inline-block w-100 mb-15">
                <Video
                  src={this.props.video}
                  id="file"
                  style={{ display: "none" }}
                  type="file"
                  name="video"
                  accept="video/*"
                  onChange={this.props.videoHandler.bind(this)}
                  count={this.props.count}
                  fileData={this.props.fileData}
                  displayCustomPopup={this.props.displayCustomPopup}
                  displayImagePopup={this.props.displayImagePopup}
                  displayCreationSuite={this.props.displayCreationSuite}
                  closePopUp={this.props.closePopUp}
                  openPopUp={this.props.openPopUp}
                  imagePopup={this.props.imagePopup}
                  popupControl={this.props.popupControl}
                  fileUpload={this.props.fileUpload}
                  uploadApi={this.props.uploadApi}
                  openCreationSuite={this.props.openCreationSuite}
                  closeCreationSuite={this.props.closeCreationSuite}
                  handleCreationSuiteUpload={this.props.handleCreationSuiteUpload}
                />
              </div>
              {!this.props.hasVideo ? (
                <TextTheme
                  message="Please upload a video or photo sharing your experiences. Maximum 2MB accepted for GIFs."
                  className="mt-1 text_small text_red mb-15"
                />
              ) : null}
              <div className="navigate-save">
                <TwoButtonLayout
                  button1Text="SAVE"
                  button2Text="COMPLETE PROJECT"
                  button1Click={(event) =>
                    this.props.saveHandler(event, "save")
                  }
                  button2Click={(event) =>
                    this.props.saveHandler(event, "done")
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DevelopNewHabitComponent;
